import React from 'react';

const PasswordControl = ({ name, value, className, onChange }) => {     
    const _value = value === null || value === undefined ? '' : value;

    return (
        <input 
            type="password"
            autoComplete="off"
            className={className || 'form-control'} 
            name={name} 
            value={_value}   
            onChange={(e) => onChange(e.target.value)} /> 
    )
}

export default PasswordControl;